const STATUS_ENUM = {
  PENDING: 'Pending',
};

export default STATUS_ENUM;
